import $ from 'jquery'
import CONSTS from '../constants'

export default class Component {
  constructor(ctx, ev) {
    this.ctx = ctx
    this.$ctx = $(ctx)
    this.ev = ev

    this.active = false

    if (this.$ctx.length > 0) {
      if (CONSTS.DEBUG) {
        window.console.log(`init: ${this.constructor.name} on ctx: ${ctx}`)
      }

      this.active = true
    } else {
      const errorMsg = `could not init: ${this.constructor.name} on ctx: ${ctx}`

      if (CONSTS.DEBUG) {
        window.console.info(errorMsg)
      }

      throw errorMsg
    }

    // easings
    this.easings = {}

    // durations
    this.durations = {
      animationInNormal: 500,
      animationOutNormal: 500,
      animationInSideNavi: 500,
      animationOutSideNavi: 500,
      tabOpen: 400,
      tabClose: 400,
    }

    // classes
    this.classes = {
      btnClose: '.h-btn-close',
    }

    // class states
    this.classStates = {
      hidden: 'h-state--hidden',
      visible: 'h-state--visible',
      active: 'h-state--active',
      loaded: 'h-state--loaded',
      fadeIn: 'h-state--fade-in',
    }

    // default events (resizes)
    this.ev.on(CONSTS.EVENTS.RESIZE, (winWidth, winHeight) => {
      this.onResize(winWidth, winHeight)
    })

    this.ev.on(CONSTS.EVENTS.RESIZE_DEBOUNCED, (winWidth, winHeight) => {
      this.onResizeDebounced(winWidth, winHeight)
    })
  }

  onResize(/* winWidth, winHeight */) {
    if (CONSTS.DEBUG) {
      window.console.log(`resizing ${this.constructor.name}`)
    }
  }

  onResizeDebounced(/* winWidth, winHeight */) {
    // noop
  }
}
